/**
 * WordPress dependencies
 */
import { PanelBody, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
const { HeaderTabs, BackgroundControl, IconPickerControl } = window.faqmateModules;

// obj attributes
import objAttributes from './attributes';

// constants
import { B_BG } from './constants';

const Inspector = props => {
    const { attributes, setAttributes } = props;
    const {
        title,
        sourceType,
        icon,

        // style
        titleColor,
        perCentange
    } = attributes;

    const objAttrs = { attributes, setAttributes, objAttributes };

    return (
        <HeaderTabs
            generalControls={
                <>
                    <PanelBody initialOpen={true}>
                        <TextControl
                            label={__('Label', 'faqmate-blocks')}
                            value={title}
                            onChange={v =>
                                setAttributes({
                                    title: v
                                })
                            }
                        />
                        {sourceType === 'library' && (
                            <IconPickerControl
                                label={__('Select Icon', 'faqmate-blocks')}
                                value={icon}
                                onChange={v => {
                                    setAttributes({
                                        icon: v
                                    });
                                }}
                            />
                        )}
                    </PanelBody>
                </>
            }
            styleControls={
                <>
                    <PanelBody title={__('Container', 'faqmate-blocks')} initialOpen={false}>
                        <BackgroundControl label={__('Background ', 'faqmate-blocks')} controlName={B_BG} objAttrs={objAttrs} />
                    </PanelBody>
                </>
            }
        />
    );
};

export default Inspector;
